import RefDokter from "@/services/bridgingVclaim/RefDokter";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ store, dynamic: true, name: "storeRefDokter" })
class RefDokterStore extends VuexModule {
  refDokter = [];



  @Mutation SET_REF_DOKTER(refDokter) {
    this.refDokter = refDokter;
  }

  @Action act_ref_dokter(nama) {
    const dt = RefDokter.getRefDokter(nama)
    dt.then(dt => {
      const refDokter = dt.data
      this.SET_REF_DOKTER(refDokter);
    });
  }


}

export const storeRefDokter = getModule(RefDokterStore);
